import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
    userId: '',
    userName: '',
    firstName:'',
    lastName:'',
    authority: [],
    isSideNav: false,
    showPlatformFeePopup:false,
    rawDueAmount: 0,
    platformFeeDueLastPaid: null,
    domain: null,
}

export const userSlice = createSlice({
	name: 'auth/user',
	initialState,
	reducers: {
        setUser: (_, action) => action.payload,
        updateSideNav: (state, action) => {
            state.isSideNav = action.payload
        },
        updateUserData: (state, action) => {
            // state = {...state, ...action.payload}
            state.firstName = action.payload.firstName
            state.lastName = action.payload.lastName
        },
        updatePlatFormFeeDue:(state,action)=>{
          state.showPlatformFeePopup = action.payload
        },
        userLoggedOut: () => initialState,
	},
})

export const { setUser,userLoggedOut, updateUserData, updateSideNav,updatePlatFormFeeDue } = userSlice.actions

export default userSlice.reducer